import React, { useEffect, useContext } from "react";
import { Box, Button, Heading, Flex } from "@chakra-ui/react";
import { Formik, Form } from "formik";
import { PurchasesContext } from "../Context/PurchasesContext";
import CustomField from "../Common/Form/CustomField";

const ProductsFilter = () => {
  const { getPurchases } = useContext(PurchasesContext);

  useEffect(() => {
    getPurchases();
  }, []);

  const handleSubmit = (values) => {
    let queries = {};
    if (values.businessName) queries.businessName = values.businessName;
    getPurchases(queries);
  };

  return (
    <>
      <Heading variant="h2">Filtros</Heading>

      <Box>
        <Formik
          initialValues={{ businessName: "" }}
          onSubmit={(values, actions) => {
            handleSubmit(values);
            actions.setSubmitting(false);
          }}
        >
          {(props) => (
            <Form>
              <Flex
                flexDirection={["column", "column", "row"]}
                justifyContent="center"
                gap={"2rem"}
              >
                <Box w={["auto", "50%"]}>
                  <CustomField
                    name="businessName"
                    title="Buscador"
                    placeholder="Ingrese un proveedor"
                    props={props}
                    customFontColor="menu.700"
                  ></CustomField>
                </Box>

                <Box align="right">
                  <Button
                    mt={4}
                    colorScheme="teal"
                    isLoading={props.isSubmitting}
                    type="submit"
                  >
                    Buscar
                  </Button>
                </Box>
              </Flex>
            </Form>
          )}
        </Formik>
      </Box>
    </>
  );
};

export default ProductsFilter;
